module.exports = __webpack_public_path__ + "img/UTDEER.cea94762.png";